import { useState } from 'react';
import Header from '../../components/ui/Header';
import Sidebar from '../../components/ui/Sidebar';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';
import CampaignListTable from './components/CampaignListTable';
import CreateCampaignModal from './components/CreateCampaignModal';

const CampaignManager = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [campaigns, setCampaigns] = useState([
    {
      id: 1,
      name: "Spring Product Launch 2026",
      subject: "Introducing Our Revolutionary New Product Line",
      status: "Active",
      riskProfile: "Low",
      riskScore: 15,
      contentScore: "8.7",
      sent: 45230,
      delivered: 44687,
      createdAt: "2026-02-20T10:30:00Z",
      assignedServer: "srv-prod-01",
      canaryStatus: "passed"
    },
    {
      id: 2,
      name: "Customer Re-engagement Campaign",
      subject: "We Miss You! Here\'s 20% Off Your Next Purchase",
      status: "Scheduled",
      riskProfile: "Medium",
      riskScore: 52,
      contentScore: "6.2",
      sent: 0,
      delivered: 0,
      createdAt: "2026-02-22T14:15:00Z",
      assignedServer: "srv-canary-01",
      canaryStatus: "not_run"
    },
    {
      id: 3,
      name: "Weekly Newsletter - Feb 24",
      subject: "This Week\'s Top Stories and Updates",
      status: "Draft",
      riskProfile: "Low",
      riskScore: 12,
      contentScore: "9.1",
      sent: 0,
      delivered: 0,
      createdAt: "2026-02-24T09:00:00Z",
      assignedServer: null,
      canaryStatus: "not_run"
    },
    {
      id: 4,
      name: "Flash Sale Announcement",
      subject: "24-Hour Flash Sale - Up to 50% Off Everything!",
      status: "Completed",
      riskProfile: "High",
      riskScore: 73,
      contentScore: "4.3",
      sent: 78450,
      delivered: 72103,
      createdAt: "2026-02-18T08:00:00Z",
      assignedServer: "srv-canary-01",
      canaryStatus: "failed"
    },
    {
      id: 5,
      name: "Customer Feedback Survey",
      subject: "Help Us Improve - Share Your Thoughts",
      status: "Active",
      riskProfile: "Low",
      riskScore: 18,
      contentScore: "8.9",
      sent: 12340,
      delivered: 12217,
      createdAt: "2026-02-21T11:45:00Z",
      assignedServer: "srv-prod-02",
      canaryStatus: "passed"
    },
    {
      id: 6,
      name: "Holiday Special Promotion",
      subject: "Exclusive Holiday Deals Just for You",
      status: "Paused",
      riskProfile: "Medium",
      riskScore: 48,
      contentScore: "5.8",
      sent: 23450,
      delivered: 21789,
      createdAt: "2026-02-19T16:30:00Z",
      assignedServer: "srv-prod-03",
      canaryStatus: "passed"
    }
  ]);

  const contactLists = [
    {
      id: "list-1",
      name: "Premium Customers - Platinum Tier",
      subscriberCount: 8920,
      averageEngagement: 95,
      openRate: 58.7,
      clickRate: 32.4,
      tier: "Platinum",
      isGoldenList: true,
      tiers: {
        platinum: 8920,
        gold: 0,
        silver: 0,
        bronze: 0,
        lead: 0
      },
      segments: [
        { name: "VIP Tier", count: 2340 },
        { name: "Premium Plus", count: 3580 },
        { name: "Premium Standard", count: 3000 }
      ]
    },
    {
      id: "list-2",
      name: "Active Subscribers - Gold Tier",
      subscriberCount: 15420,
      averageEngagement: 88,
      openRate: 52.3,
      clickRate: 28.1,
      tier: "Gold",
      isGoldenList: false,
      tiers: {
        platinum: 0,
        gold: 15420,
        silver: 0,
        bronze: 0,
        lead: 0
      },
      segments: [
        { name: "High Engagement", count: 8420 },
        { name: "Regular Engagement", count: 7000 }
      ]
    },
    {
      id: "list-3",
      name: "Regular Subscribers - Silver Tier",
      subscriberCount: 12340,
      averageEngagement: 72,
      openRate: 42.5,
      clickRate: 18.3,
      tier: "Silver",
      isGoldenList: false,
      tiers: {
        platinum: 0,
        gold: 0,
        silver: 12340,
        bronze: 0,
        lead: 0
      },
      segments: [
        { name: "Medium Engagement", count: 7340 },
        { name: "Low Engagement", count: 5000 }
      ]
    },
    {
      id: "list-4",
      name: "Inactive Users - Bronze Tier",
      subscriberCount: 6780,
      averageEngagement: 58,
      openRate: 28.2,
      clickRate: 10.7,
      tier: "Bronze",
      isGoldenList: false,
      tiers: {
        platinum: 0,
        gold: 0,
        silver: 0,
        bronze: 6780,
        lead: 0
      },
      segments: [
        { name: "Recently Inactive", count: 3670 },
        { name: "Long-term Inactive", count: 3110 }
      ]
    },
    {
      id: "list-5",
      name: "New Leads - Lead Tier",
      subscriberCount: 1770,
      averageEngagement: 35,
      openRate: 18.2,
      clickRate: 6.5,
      tier: "Lead",
      isGoldenList: false,
      tiers: {
        platinum: 0,
        gold: 0,
        silver: 0,
        bronze: 0,
        lead: 1770
      },
      segments: [
        { name: "Week 1", count: 890 },
        { name: "Week 2-4", count: 880 }
      ]
    }
  ];

  const handleCreateCampaign = (newCampaign) => {
    setCampaigns([newCampaign, ...campaigns]);
  };

  const handleViewCampaign = (campaign) => {
    console.log('View campaign:', campaign);
  };

  const handleEditCampaign = (campaign) => {
    console.log('Edit campaign:', campaign);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <Sidebar 
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
      />
      <main 
        className={`pt-20 transition-all duration-300 ${
          isSidebarCollapsed ? 'lg:pl-20' : 'lg:pl-[280px]'
        }`}
      >
        <div className="p-4 md:p-6 lg:p-8">
          <div className="mb-6 md:mb-8">
            <Breadcrumbs />
          </div>

          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6 md:mb-8">
            <div>
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground mb-2">
                Campaign Manager
              </h1>
              <p className="text-sm md:text-base text-muted-foreground">
                Create, monitor, and optimize email campaigns with predictive analytics
              </p>
            </div>

            <Button
              variant="default"
              size="lg"
              iconName="Plus"
              iconPosition="left"
              onClick={() => setIsCreateModalOpen(true)}
              className="w-full md:w-auto"
            >
              Create Campaign
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-6 md:mb-8">
            <div className="bg-card rounded-lg border border-border p-4 md:p-6">
              <div className="flex items-center justify-between mb-3">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Icon name="Mail" size={20} className="text-primary" />
                </div>
                <Icon name="TrendingUp" size={16} className="text-success" />
              </div>
              <div className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-1">
                {campaigns?.length}
              </div>
              <div className="text-sm text-muted-foreground">
                Total Campaigns
              </div>
            </div>

            <div className="bg-card rounded-lg border border-border p-4 md:p-6">
              <div className="flex items-center justify-between mb-3">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-success/10 flex items-center justify-center">
                  <Icon name="CheckCircle2" size={20} className="text-success" />
                </div>
                <Icon name="TrendingUp" size={16} className="text-success" />
              </div>
              <div className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-1">
                {campaigns?.filter(c => c?.status === 'Active')?.length}
              </div>
              <div className="text-sm text-muted-foreground">
                Active Campaigns
              </div>
            </div>

            <div className="bg-card rounded-lg border border-border p-4 md:p-6">
              <div className="flex items-center justify-between mb-3">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-warning/10 flex items-center justify-center">
                  <Icon name="Clock" size={20} className="text-warning" />
                </div>
                <Icon name="TrendingUp" size={16} className="text-warning" />
              </div>
              <div className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-1">
                {campaigns?.filter(c => c?.status === 'Scheduled')?.length}
              </div>
              <div className="text-sm text-muted-foreground">
                Scheduled
              </div>
            </div>

            <div className="bg-card rounded-lg border border-border p-4 md:p-6">
              <div className="flex items-center justify-between mb-3">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-secondary/10 flex items-center justify-center">
                  <Icon name="BarChart3" size={20} className="text-secondary-foreground" />
                </div>
                <Icon name="TrendingUp" size={16} className="text-success" />
              </div>
              <div className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-1">
                92.4%
              </div>
              <div className="text-sm text-muted-foreground">
                Avg Delivery Rate
              </div>
            </div>
          </div>

          <CampaignListTable
            campaigns={campaigns}
            onViewCampaign={handleViewCampaign}
            onEditCampaign={handleEditCampaign}
          />
        </div>
      </main>
      <CreateCampaignModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        onCreateCampaign={handleCreateCampaign}
        contactLists={contactLists}
      />
    </div>
  );
};

export default CampaignManager;